import BaseWidget from '@/plugins/dashboard/classes/BaseWidget'
import Widget from '@/components/Dashboard/WidgetPanel'
import createConfigure from '@/plugins/dashboard/widgets/Base/createConfigure'
import { widgetPanel } from '@/plugins/dashboard/widgets/Base/definitions'

export default class extends BaseWidget {
  static name = widgetPanel.name
  static widget = Widget
  static configure = createConfigure(widgetPanel)
}
